import { cn, PresentationScope } from '@workspace/app-components';
import { type ComponentProps } from 'react';
import '@cardforest/renderer/hud.css';

export function TableSurface({ children, className, ...props }: ComponentProps<'div'>) {
  return (
    <div
      {...props}
      data-document-example
      className={cn(
        'game-theme relative isolate min-w-0 overflow-hidden rounded-xl border border-emerald-900/40 bg-gradient-to-br from-emerald-800 via-emerald-700 to-emerald-800 p-6 shadow-inner',
        className,
      )}
    >
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_30%_40%,rgba(255,255,255,0.04),transparent_60%)]" />
      <div className="et-hud h-full" style={{ position: 'relative', inset: 'auto', zIndex: 'auto' }}>
        <PresentationScope>{children}</PresentationScope>
      </div>
    </div>
  );
}
